import { Locale } from '@enmon/commons';

export const MAP_LOCALE_TO_DATE_FORMATS: Record<Locale, string[]> = {
  [Locale.CS]: ['D.M.YYYY', 'DD.MM.YYYY'],
  [Locale.SK]: ['D.M.YYYY', 'DD.MM.YYYY'],
  [Locale.PL]: ['D.M.YYYY', 'DD.MM.YYYY'],
  [Locale.EN]: ['M/D/YYYY', 'MM/DD/YYYY'],
};

/**
 * This ID is the identifier for dynamic import error messages
 * and is the prefix for the given translation error message.
 * (e.g. `app.dynamic.importFormError.{import panel Id}.{error path}.{error type}`
 * will be the translation key in JSON translation files)
 */
export const IMPORT_ERROR_DYNAMIC_MESSAGE_ID = 'app.dynamic.importFormError' as const;

/**
 * This ID is the identifier for dynamic import error messages
 * and is the prefix for the given translation error message.
 * (e.g. `app.dynamic.basicFormError.{form Id}.{error path}.{error type}`
 * will be the translation key in JSON translation files)
 */
export const BASIC_FORM_ERROR_DYNAMIC_MESSAGE_ID = 'app.dynamic.basicFormError' as const;
